import { getNavigatorInfo } from '../../utils/navigator.service';

export class LoginRequest {
  public flow_id: string;
  public cookie: string;
  public platform: number;
  public version: string;
  public description: string;
  public appVersion: string;
  public uuid: string;

  constructor() {
    this.version = getNavigatorInfo().version || '4.9.2';
    this.description = 'Pix-Web';
    this.platform = 1;
    this.flow_id = '';
    this.cookie = '';
    this.appVersion = '';
    this.uuid = '';
  }
}
